import React from 'react';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { captureNavigation } from '../../../analytics';
import Button from '../../../components/Button';
import '../styles.css';

type Props = {
  intl: {
    messages: [];
    formatMessage: Function;
    locale: string,
  };
  setIsModalVisible: Function;
};

const Header: React.FC<Props> = ({ intl, setIsModalVisible }) => {
  return (
    <div className="sc-header">
      <p id="page-title">{intl.messages['categories.title']}</p>
      <div className="buttons">
        <Button
          variant="contained"
          onClick={() => setIsModalVisible(true)}
        >
          {intl.messages['categories.create']}
        </Button>
      </div>
    </div>
  );
};

export default injectIntl(Header);
